"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_STAGING = exports.IS_PROD = exports.IS_DEV = exports.getEnv = void 0;
const getEnv = () => {
    if (process.env.REACT_APP_ENVIRONMENT)
        return process.env.REACT_APP_ENVIRONMENT;
    if (typeof window === 'undefined') {
        return 'development';
    }
    const { hostname } = window.location;
    if (hostname.includes('-staging.managed.services.opendoor.com')) {
        return 'staging';
    }
    else if (hostname.includes('.opendoor.com')) {
        return 'production';
    }
    else {
        return 'development';
    }
};
exports.getEnv = getEnv;
const env = exports.getEnv();
exports.IS_DEV = env === 'development';
exports.IS_PROD = env === 'production';
exports.IS_STAGING = env === 'staging';
